import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contact } from './model/contact';
import { mail } from './model/Mail';
import { careers } from './model/careers';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EngineeeringService {
  url: string = 'https://mail.capplite.it/mail';
  //url: string = 'http://localhost:5010/mail';
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json', 'Access-Control-Allow-Headers': '*', 'ApiKey': 'fa33307a-f0f4-462f-a769-454230fd403e'
    })
  };




  sendMailContact(mailContact: contact): Observable<any> {
    var m = new mail({});
    m.subject = "Email pagina informazioni";
    m.message = "Hai ricevuto una richiasta di informazioni dal signor " + mailContact.lastName + " " + mailContact.firstName + ": Messaggio: " + mailContact.message + " ,contattalo al numero "
      + mailContact.phone + " o alla mail " + mailContact.email;
    m.emailTo = ["sala.j@capp.it"];
    m.aliasName = "Capp-enginnering";
    return this.http.post(this.url +"/file", m, this.httpOptions);
  }

  sendMailCareers(mailCareers: careers): Observable<any> {
    var m = new mail({});
    m.subject = "Email pagina carriera";
    m.message = "Hai ricevuto una richiasta di informazioni dal signor " + mailCareers.surname + " " + mailCareers.name + ": "
    +"Nome: " + mailCareers.name + ", Cognome: " + mailCareers.surname 
    + ", Ruolo: " + mailCareers.jobRole
    + ", Messaggio: "  
    
    + mailCareers.message + ",Contattalo al numero: "
      + mailCareers.phone + ",mail: " + mailCareers.email;
    m.emailTo = ["sala.j@capp.it"];
    m.aliasName = "Capp-enginnering";
    m.attachmentName = mailCareers.curriculum.name;

    const obs = new Observable(observer => {
      const reader = new FileReader();
      reader.readAsDataURL(mailCareers.curriculum);
      reader.onload = () => {
        observer.next(reader.result);
        observer.complete();
      }
    })

    

    return obs.pipe(switchMap((cv: string) => {
      m.attachment = cv.split(',')[1];
      return this.http.post(this.url + "/file", m, this.httpOptions);
    }))
  }

}
